import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { StockMarketTitle } from "../../../../Constants/Constants";
import ReactApexChart from "react-apexcharts";
import { StockMarketChart } from "../../../../Data/General/Widgets/Chart";

const StockMarket = () => {
  return (
    <Col sm="12" className="box-col-12">
      <div className="donut-chart-widget">
        <Card>
          <CommonCardHeader title={StockMarketTitle} />
          <CardBody>
            <div id="chart-widget13">
              <ReactApexChart options={StockMarketChart} series={StockMarketChart.series} type="line" height={450} />
            </div>
          </CardBody>
        </Card>
      </div>
    </Col>
  );
};

export default StockMarket;
